// Mock data for Golden Moment Website

export const portfolioPhotos = [
  {
    id: 1,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding1.jpg',
    alt: ''
  },
  {
    id: 2,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding2.jpg',
    alt: ''
  },
  {
    id: 3,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding3.jpg',
    alt: ''
  },
  {
    id: 4,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding7.jpg',
    alt: ''
  },
  {
    id: 5,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding8.jpg',
    alt: ''
  },
  {
    id: 6,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding9.jpg',
    alt: ''
  },
  {
    id: 7,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding4.jpg',
    alt: ''
  },
  {
    id: 8,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding5.jpg',
    alt: ''
  },
  {
    id: 9,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding6.jpg',
    alt: ''
  },
  {
    id: 10,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding10.jpg',
    alt: ''
  },
  {
    id: 11,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding11.jpg',
    alt: ''
  },
  {
    id: 12,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding12.jpg',
    alt: ''
  },
  {
    id: 13,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding13.jpg',
    alt: ''
  },
  {
    id: 14,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding14.jpg',
    alt: ''
  },
  {
    id: 15,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding15.jpg',
    alt: ''
  },
  {
    id: 16,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding16.jpg',
    alt: ''
  },
  {
    id: 17,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding17.jpg',
    alt: ''
  },
  {
    id: 18,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding18.jpg',
    alt: ''
  },
{
    id: 19,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding19.jpg',
    alt: ''
  },
  {
    id: 20,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding20.jpg',
    alt: ''
  },
  {
    id: 21,
    category: 'wedding',
    imageUrl: 'photo/wedding/wedding21.jpg',
    alt: ''
  },

  {
    id: 22,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed1.jpg',
    alt: ''
  },
  {
    id: 23,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed2.jpg',
    alt: ''
  },
  {
    id: 24,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed3.jpg',
    alt: ''
  },
{
    id: 25,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed4.jpg',
    alt: ''
  },
  {
    id: 26,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed5.jpg',
    alt: ''
  },
  {
    id: 27,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed6.jpg',
    alt: ''
  },
  {
    id: 28,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed7.jpg',
    alt: ''
  },
  {
    id: 29,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed8.jpg',
    alt: ''
  },
  {
    id: 30,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed9.jpg',
    alt: ''
  },
  {
    id: 31,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed10.jpg',
    alt: ''
  },
  {
    id: 32,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed11.jpg',
    alt: ''
  },
  {
    id: 33,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed12.jpg',
    alt: ''
  },
  {
    id: 34,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed13.jpg',
    alt: ''
  },
  {
    id: 35,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed14.jpg',
    alt: ''
  },
  {
    id: 36,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed15.jpg',
    alt: ''
  },
  {
    id: 37,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed16.jpg',
    alt: ''
  },
  {
    id: 38,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed17.jpg',
    alt: ''
  },
  {
    id: 39,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed18.jpg',
    alt: ''
  },
  {
    id: 40,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed19.jpg',
    alt: ''
  },
  {
    id: 41,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed20.jpg',
    alt: ''
  },
  {
    id: 42,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed21.jpg',
    alt: ''
  },
  {
    id: 43,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed22.jpg',
    alt: ''
  },
  {
    id: 44,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed23.jpg',
    alt: ''
  },
  {
    id: 45,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed24.jpg',
    alt: ''
  },
  {
    id: 46,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed25.jpg',
    alt: ''
  },
  {
    id: 47,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed26.jpg',
    alt: ''
  },
  {
    id: 48,
    category: 'prewedding',
    imageUrl: 'photo/prewed/prewed27.jpg',
    alt: ''
  }
];

export const portfolioVideos = [
  {
    id: 1,
    category: 'wedding',
    youtubeId: '2LHrQhqXOqY',
    thumbnail: 'https://img.youtube.com/vi/2LHrQhqXOqY/maxresdefault.jpg',
    title: 'Video Wedding'
  },
  {
    id: 2,
    category: 'wedding',
    youtubeId: 'uHjRnJ7S-84',
    thumbnail: 'photo/thumbnail1.jpg',
    title: 'Video Wedding'
  },
  {
    id: 3,
    category: 'wedding',
    youtubeId: 'MGS3hdFRSRM',
    thumbnail: 'photo/thumbnail2.jpg',
    title: 'Video Prewedding 2'
  },
  {
    id: 4,
    category: 'wedding',
    youtubeId: 'GCkXrgtVhcU',
    thumbnail: 'photo/thumbnail3.jpg',
    title: 'Video Wedding 2'
  },
  /*{
    id: 5,
    category: 'prewedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Prewedding 3'
  },
  {
    id: 6,
    category: 'wedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Wedding 3'
  },
  {
    id: 7,
    category: 'prewedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Prewedding 4'
  },
  {
    id: 8,
    category: 'wedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Wedding 4'
  },
  {
    id: 9,
    category: 'prewedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Prewedding 5'
  },
  {
    id: 10,
    category: 'wedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Wedding 5'
  },
  {
    id: 11,
    category: 'prewedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Prewedding 6'
  },
  {
    id: 12,
    category: 'wedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Wedding 6'
  },
  {
    id: 13,
    category: 'prewedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Prewedding 7'
  },
  {
    id: 14,
    category: 'wedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Wedding 7'
  },
  {
    id: 15,
    category: 'prewedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Prewedding 8'
  },
  {
    id: 16,
    category: 'wedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Wedding 8'
  },
  {
    id: 17,
    category: 'prewedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Prewedding 9'
  },
  {
    id: 18,
    category: 'wedding',
    youtubeId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    title: 'Video Wedding 9'
  }*/
];

export const testimonials = [
  {
    id: 1,
    name: 'Rina & Andi',
    image: 'https://images.unsplash.com/photo-1759096516312-4ac01cf358f3?w=200&q=75',
    text: 'Golden Moment berhasil mengabadikan setiap momen spesial kami dengan sempurna. Hasilnya sangat memuaskan dan profesional!'
  },
  {
    id: 2,
    name: 'Dian & Budi',
    image: 'https://images.unsplash.com/photo-1634794251656-9f286d822b05?w=200&q=75',
    text: 'Tim yang sangat ramah dan kreatif. Mereka membuat kami merasa nyaman di depan kamera. Hasil fotonya luar biasa indah!'
  },
  {
    id: 3,
    name: 'Sari & Rudi',
    image: 'https://images.unsplash.com/photo-1634795776422-5a85c8e0f1ce?w=200&q=75',
    text: 'Terima kasih Golden Moment! Kalian mengabadikan hari pernikahan kami dengan sangat apik dan penuh emosi. Recommended!'
  },
  {
    id: 4,
    name: 'Maya & Eko',
    image: 'https://images.pexels.com/photos/5217854/pexels-photo-5217854.jpeg?auto=compress&cs=tinysrgb&w=200',
    text: 'Prewedding kami menjadi pengalaman yang menyenangkan berkat Golden Moment. Hasilnya melebihi ekspektasi kami!'
  },
  {
    id: 5,
    name: 'Fitri & Hendra',
    image: 'https://images.pexels.com/photos/4098374/pexels-photo-4098374.jpeg?auto=compress&cs=tinysrgb&w=200',
    text: 'Profesional, kreatif, dan detail. Golden Moment adalah pilihan terbaik untuk dokumentasi pernikahan kami!'
  },
  {
    id: 6,
    name: 'Dewi & Adi',
    image: 'https://images.unsplash.com/photo-1759701788724-df6b41660b96?w=200&q=75',
    text: 'Sangat puas dengan hasil foto dan video wedding kami. Tim Golden Moment sangat mengerti keinginan kami. Top!'
  }
];

export const services = [
  {
    id: 1,
    title: 'Foto Prewedding',
    description: 'Dokumentasi momen spesial sebelum pernikahan dengan konsep yang kreatif dan romantis.'
  },
  {
    id: 2,
    title: 'Video Prewedding',
    description: 'Cinematic video yang mengabadikan kisah cinta Anda dengan sentuhan sinematik profesional.'
  },
  {
    id: 3,
    title: 'Foto Wedding',
    description: 'Dokumentasi lengkap hari pernikahan Anda dari awal hingga akhir dengan detail sempurna.'
  },
  {
    id: 4,
    title: 'Video Wedding',
    description: 'Video cinematic hari spesial Anda yang akan menjadi kenangan indah selamanya.'
  }
];

export const stats = [
  {
    id: 1,
    number: '7+',
    label: 'Tahun Pengalaman'
  },
  {
    id: 2,
    number: '100+',
    label: 'Klien'
  },
  {
    id: 3,
    number: '120+',
    label: 'Proyek Dokumentasi'
  }
];